module.exports = __webpack_public_path__ + "img/charity_pig.30b04d59.svg";